// 苹果登录使用
import type { appleSignInInterface } from '@/types/viewsType/loginType'

// 初始化
function init() {
  const runtimeConfig = useRuntimeConfig()
  window['AppleID'].auth.init({
    clientId: runtimeConfig.public.appleClientId, // ID
    scope: 'name', // 作用域 如 name email
    redirectURI: runtimeConfig.public.appleLoginRedirectUrl, // 登录回调页面地址
    state: '', // 状态
    usePopup: true //or false defaults to false
  })
}

// 登录
/** 返回格式
 {
     "authorization": {
       "code": "[CODE]",
       "id_token": "[ID_TOKEN]",
       "state": "[STATE]"
     },
     "user": {
       "email": "[EMAIL]",
       "name": {
         "firstName": "[FIRST_NAME]",
         "lastName": "[LAST_NAME]"
       }
     }
}
**/
async function signIn(): Promise<appleSignInInterface> {
  const data: appleSignInInterface = await window['AppleID'].auth.signIn()
  return data
}

export default {
  init,
  signIn
}
